/* ZDateFunct
Versione 2.9.4 - 08 aprile 2026 - Migliazzi Federico
                 CHG: aggiunta gestione degli errori in FormatDateTime
Versione 2.8.4 - 27 Gennaio 2026 - Nicole Acciai
                 NEW: Inserita funzione per ottenere il primo giorno feriale
Versione 2.7.4 - 15 Settembre 2024 - Dario Scianna
                 NEW: Inserita funzione per usare i mesi nella DataTable
Versione 2.6.4 - 16 Luglio 2024 - Mauro Brasile
                 NEW: Inserite le costanti MS_X_DAY, MS_X_HOUR, MS_X_MINUTE
Versione 2.5.4 - 31 Maggio 2024 - Francesco Ardini
                 NEW: Inserita const TIME_ZONES
Versione 2.4.4 - 17 Maggio 2024 - Mauro Brasile
                 NEW: Inserita la costante LISTA_ORE
Versione 2.3.4 - 20 Gennaio 2024 - Mauro Brasile
                 FIX: Sistemato baco nel controllo dell'anno bisestile
Versione 2.3.3 - 01 Dicembre 2023 - Francesco Ardini
                 NEW: Aggiunta funzione ChangeDate 
Varsione 2.2.3 - 02 Agosto 2023 - Francesco Ardini
                 FIX: Risolto bug nella FormatDateTime
Versione 2.2.2 - 19 Maggio 2023 - Francesco Ardini
                 NEW: Introdotta la funzione CheckMinore che controlla se la persona la cui data di nascita viene passata è minorenne o meno
Versione 2.1.2 - 17 Maggio 2023 - Massimiliano Zirilli
                 FIX: ZFormatDateTime. Errore nella gestione del tag Mi
                 NEW: Introdotta esportazione del giorno in italiano in FormatDateTime
Versione 2.0.1 - 7 Aprile 2023 - Brasile Mauro
                 FIX: nella SumMonth era ancora presente la vecchia funzione GetNGiorniMese
                      sostituita con la GetLunghezzaMese
Versione 2.0.0 - 02 Febbraio 2023 - Massimiliano Zirilli
                 NON RETROCOMPATIBILE 
                 FIX: Problemi gravi nel calcolo della lunghezza dei mesi degli anni 
                      bisestili.
                      Cambiato il nome delle vecchie procedure per verificare codice
                      esistente
                 NEW: Introdotta la funzione IncMese
Versione 1.2.1 - 22 Settembre 2022 - Massimiliano Zirilli
                 FIX: Corretto problema nella gestione della lunghezza dei mesi
Versione 1.2.0 - 17 Settembre 2022 - Massimiliano Zirilli
                 NEW: Aggiunta funzione che torna la lunghezza di un mese
Versione 1.1.0 - 05 Settemebre 2022 - Brasile Mauro
                 CHG: Alla DateFromHTMLInput si passa una sola stringa anzichè due
                      Si considera presente l'orario se esiste una seconda stringa
                      separata da spazio
Versione 1.0.0 - 20 Agosto 2022 - Massimiliano  Zirilli
                 Prima versione
*/

const LUNGHEZZA_MESI = [31 , 28 , 31 , 30 , 31 , 30 , 31 , 31 , 30 , 31 , 30 , 31];

export const MS_X_MINUTE = 60000; 
export const MS_X_HOUR   = 3600000; 
export const MS_X_DAY    = 86400000; 

export const LISTA_ORE = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];

export class TZDateFunct
{
  static GetMesiInItaliano()
  {
    return ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
            'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];
  }

  static GetGiorniInItaliano()
  {
    return ['Domenica','Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'];
  }

  static GetPrimoGiornoFeriale(Data,NumGiorni = 0)
  {
    var Futura = new Date(Data)
    Futura.setDate(Futura.getDate() + NumGiorni)
    var GiornoSett = Futura.getDay()

    if (GiornoSett == 0)
    {
      Futura.setDate(Futura.getDate() + 1)
    }
    if (GiornoSett == 6)
    {
      Futura.setDate(Futura.getDate() + 2)
    }
    return Futura
  }

  static AnnoBisestile(Anno)
  {
    return (Anno % 400 == 0) || ((Anno % 4 == 0 && Anno % 100 != 0))
  }

  // Calcola la lunghezza del mese. 
  //Se non passa l'anno considera il Mese in formato 0 .. 11 come tornato
  // dalla GetMonth altrimenti considera il formato
  // Anno * 100 + Mese come tornato dall'input type="month"
  static GetLunghezzaMese(Mese,Anno)
  {
    if(Anno == undefined)
    { 
      Anno = Math.trunc(Mese / 100);
      Mese = Mese % 100;
    }
    else Mese++
    var Result = LUNGHEZZA_MESI[Mese - 1]
    if((Mese == 2) && (TZDateFunct.AnnoBisestile(Anno)))
      Result = 29
    return Result
  }
  
  static GetDateOfWeek(NrSettimana, Anno) 
  {
    var Giorno = (1 + (NrSettimana - 1) * 7);

    return new Date(Anno, 0, Giorno);
  }

  static IncrementDate(Data,GiorniToAdd) 
  {
    return new Date(Data.getTime() +(GiorniToAdd *86400000));
  }  

  static DecreaseDate(Data,GiorniToSubtract)
  {
    return new Date(Data.getTime() - (GiorniToSubtract * 86400000))
  }

  static DecreaseOra(Data, OreDaSottrarre)
  {
    return new Date(Data.getTime() - (OreDaSottrarre * 3600000)) 
  }

  static ChangeDate(Data, UnitaDiMisura, Grandezza)
  {
    if (!(Data instanceof Date))
      Data = new Date(Data)
    let TimeFormat = Data.getTime()
    switch (UnitaDiMisura)
    {
      case 'millisecond' : TimeFormat += Grandezza; break;
      case 'second'      : TimeFormat += (Grandezza * 1000); break;
      case 'minute'      : TimeFormat += (Grandezza * 60000); break;
      case 'hour'        : TimeFormat += (Grandezza * 3600000); break;
      case 'day'         : TimeFormat += (Grandezza * 86400000); break;
    }
    return new Date(TimeFormat)
  }

  // Incrementa il Mese passato (espresso in Anno * 100 + Mese) del numero di mesi passati
  static IncMese(Mese,NumeroMesi)
  {
    var Anno = Math.trunc(Mese / 100)
    Mese = Mese % 100

    Anno = Anno + Math.trunc(NumeroMesi / 12) 
    Mese = Mese + NumeroMesi % 12

    while(Mese > 12)
    {
      Mese = Mese - 12
      Anno = Anno + 1
    }

    return Anno * 100 + Mese
    
  }

  // Incrementa la data di N mese e si posiziona nello stesso dove è possibile, nell'ultimo 
  // quando non esiste
  static SumMonth(Data,N_Mesi)
  {
    var Giorno;
    var Mese;
    var Anno;
    if(N_Mesi == undefined || isNaN(N_Mesi)) N_Mesi = 0;
    Anno = Data.getFullYear();
    Mese = Data.getMonth();
    Giorno = Data.getDate();
    while(N_Mesi != 0) 
    {
       if(N_Mesi > 0)
       {
           N_Mesi-- ;
           if(Mese != 11)
              Mese++;
           else
           {
             Mese = 0 ;
             Anno++;
           }
       }
       else
       {
         N_Mesi++; 
         if(Mese != 0)
            Mese--;
         else
         {
           Mese = 11;
           Anno--;
         }
       }
    }
    
    if(TZDateFunct.GetLunghezzaMese(Mese,Anno) < Giorno)
       Giorno = TZDateFunct.GetLunghezzaMese(Mese,Anno) ;
    return(new Date(Anno,Mese,Giorno));
  }

  static GetListaOggettiMensilita()
  {
    var Result = TZDateFunct.GetMesiInItaliano();
    for(let i = 0;i < Result.length; i++)
       Result[i] = { Id : i + 1, Descrizione : Result[i] }
    return Result;
  }

  static GetListaMensilitaPerDataTable()  //Per la DataTable servono i campi CHIAVE e DESCRIZIONE
  {
    var Result = TZDateFunct.GetMesiInItaliano();
    for(let i = 0;i < Result.length; i++)
       Result[i] = { CHIAVE : i + 1, DESCRIZIONE : Result[i] }
    return Result;
  }

  static FormatDateTime(format,dt)
  {
    if(dt == undefined || dt == null || !(dt instanceof Date) || isNaN(dt.getTime())) return("");
    
    var pad = function(Stringa,Lunghezza)
    {
      Stringa += ''; // conversione in stringa
      while(Stringa.length < Lunghezza)
            Stringa = '0' + Stringa;
      return(Stringa);
    };
    try
    {
      format = format.replace('yyyy', dt.getFullYear());
      format = format.replace('yy',  (dt.getFullYear() + "").substring(2));
      format = format.replace('mm',   pad(dt.getMonth() + 1,2));
      format = format.replace('m',    dt.getMonth() + 1);
      format = format.replace('dd',   pad(dt.getDate(),2));
      format = format.replace('d',    dt.getDate());
      format = format.replace('hh',   pad(dt.getHours(),2));
      format = format.replace('h',    dt.getHours());
      format = format.replace('nn',   pad(dt.getMinutes(),2));
      format = format.replace('n',    dt.getMinutes());
      format = format.replace('ss',   pad(dt.getSeconds(),2));
      format = format.replace('s',    dt.getSeconds());
      format = format.replace('Mi',   TZDateFunct.GetMesiInItaliano()[dt.getMonth()]);
      format = format.replace('_Di',   TZDateFunct.GetGiorniInItaliano()[dt.getDay()]);
      format = format.replace('_DI',   (TZDateFunct.GetGiorniInItaliano()[dt.getDay()]).substring(0,3));
    }
    catch(e)
    {
      throw new Error('Errore FormatDateTime: ' +  e.message)
    }
    return format;
   }
   
   static DateInHTMLInputFormat(dt)
   {
     return TZDateFunct.FormatDateTime('yyyy-mm-dd',dt)
   }
   
   static DateFromHTMLInput(DateString)
   {
     DateString = DateString.split(' ')
     var TimeString = undefined
     if(DateString.length > 1)
        TimeString = DateString[1]
     DateString = DateString[0]
     if((DateString != "") && (DateString != undefined) && (DateString != null))
     {
       var TmpData = DateString.split('-');
       if(TimeString == undefined)
          return(new Date(TmpData[0],TmpData[1] - 1,TmpData[2]))
       else
       {
        var TmpOra = TimeString.split(':');
        return(new Date(TmpData[0],TmpData[1] - 1,TmpData[2],TmpOra[0],TmpOra[1],(TmpOra.length >= 3 ? TmpOra[2] : undefined)));
       }
     }
     else return(undefined);
   }

   static GetLastDateMonth(Data)
   {
     var Anno, Mese, Giorno
     Data   = new Date(Data)
     Anno   = Data.getFullYear()
     Mese   = Data.getMonth()
     Giorno = this.GetLunghezzaMese(Mese ,Anno)
     Data   = (new Date(Anno, Mese, Giorno))
     Data   = this.DateInHTMLInputFormat(Data)
     return Data
   }

   static CheckMinore(DataNascita)
   {
     let DataOggi = new Date()
     let Anno = DataOggi.getFullYear();
     let Mese = DataOggi.getMonth()
     let Giorno = DataOggi.getDate()
     let DataMaggioreEta = TZDateFunct.DateInHTMLInputFormat(new Date(Anno - 18, Mese, Giorno))
     return (DataNascita > DataMaggioreEta)
   }

   static GetNHoursInTimeStamp(Hours)
   {
      return Hours * MS_X_HOUR;
   }
}

export const TIME_ZONES = [
                            "Africa/Abidjan",
                            "Africa/Accra",
                            "Africa/Addis_Ababa",
                            "Africa/Algiers",
                            "Africa/Asmara",
                            "Africa/Asmera",
                            "Africa/Bamako",
                            "Africa/Bangui",
                            "Africa/Banjul",
                            "Africa/Bissau",
                            "Africa/Blantyre",
                            "Africa/Brazzaville",
                            "Africa/Bujumbura",
                            "Africa/Cairo",
                            "Africa/Casablanca",
                            "Africa/Ceuta",
                            "Africa/Conakry",
                            "Africa/Dakar",
                            "Africa/Dar_es_Salaam",
                            "Africa/Djibouti",
                            "Africa/Douala",
                            "Africa/El_Aaiun",
                            "Africa/Freetown",
                            "Africa/Gaborone",
                            "Africa/Harare",
                            "Africa/Johannesburg",
                            "Africa/Juba",
                            "Africa/Kampala",
                            "Africa/Khartoum",
                            "Africa/Kigali",
                            "Africa/Kinshasa",
                            "Africa/Lagos",
                            "Africa/Libreville",
                            "Africa/Lome",
                            "Africa/Luanda",
                            "Africa/Lubumbashi",
                            "Africa/Lusaka",
                            "Africa/Malabo",
                            "Africa/Maputo",
                            "Africa/Maseru",
                            "Africa/Mbabane",
                            "Africa/Mogadishu",
                            "Africa/Monrovia",
                            "Africa/Nairobi",
                            "Africa/Ndjamena",
                            "Africa/Niamey",
                            "Africa/Nouakchott",
                            "Africa/Ouagadougou",
                            "Africa/Porto-Novo",
                            "Africa/Sao_Tome",
                            "Africa/Timbuktu",
                            "Africa/Tripoli",
                            "Africa/Tunis",
                            "Africa/Windhoek",
                            "America/Adak",
                            "America/Anchorage",
                            "America/Anguilla",
                            "America/Antigua",
                            "America/Araguaina",
                            "America/Argentina/Buenos_Aires",
                            "America/Argentina/Catamarca",
                            "America/Argentina/ComodRivadavia",
                            "America/Argentina/Cordoba",
                            "America/Argentina/Jujuy",
                            "America/Argentina/La_Rioja",
                            "America/Argentina/Mendoza",
                            "America/Argentina/Rio_Gallegos",
                            "America/Argentina/Salta",
                            "America/Argentina/San_Juan",
                            "America/Argentina/San_Luis",
                            "America/Argentina/Tucuman",
                            "America/Argentina/Ushuaia",
                            "America/Aruba",
                            "America/Asuncion",
                            "America/Atikokan",
                            "America/Atka",
                            "America/Bahia",
                            "America/Bahia_Banderas",
                            "America/Barbados",
                            "America/Belem",
                            "America/Belize",
                            "America/Blanc-Sablon",
                            "America/Boa_Vista",
                            "America/Bogota",
                            "America/Boise",
                            "America/Buenos_Aires",
                            "America/Cambridge_Bay",
                            "America/Campo_Grande",
                            "America/Cancun",
                            "America/Caracas",
                            "America/Catamarca",
                            "America/Cayenne",
                            "America/Cayman",
                            "America/Chicago",
                            "America/Chihuahua",
                            "America/Ciudad_Juarez",
                            "America/Coral_Harbour",
                            "America/Cordoba",
                            "America/Costa_Rica",
                            "America/Creston",
                            "America/Cuiaba",
                            "America/Curacao",
                            "America/Danmarkshavn",
                            "America/Dawson",
                            "America/Dawson_Creek",
                            "America/Denver",
                            "America/Detroit",
                            "America/Dominica",
                            "America/Edmonton",
                            "America/Eirunepe",
                            "America/El_Salvador",
                            "America/Ensenada",
                            "America/Fort_Nelson",
                            "America/Fort_Wayne",
                            "America/Fortaleza",
                            "America/Glace_Bay",
                            "America/Godthab",
                            "America/Goose_Bay",
                            "America/Grand_Turk",
                            "America/Grenada",
                            "America/Guadeloupe",
                            "America/Guatemala",
                            "America/Guayaquil",
                            "America/Guyana",
                            "America/Halifax",
                            "America/Havana",
                            "America/Hermosillo",
                            "America/Indiana/Indianapolis",
                            "America/Indiana/Knox",
                            "America/Indiana/Marengo",
                            "America/Indiana/Petersburg",
                            "America/Indiana/Tell_City",
                            "America/Indiana/Vevay",
                            "America/Indiana/Vincennes",
                            "America/Indiana/Winamac",
                            "America/Indianapolis",
                            "America/Inuvik",
                            "America/Iqaluit",
                            "America/Jamaica",
                            "America/Jujuy",
                            "America/Juneau",
                            "America/Kentucky/Louisville",
                            "America/Kentucky/Monticello",
                            "America/Knox_IN",
                            "America/Kralendijk",
                            "America/La_Paz",
                            "America/Lima",
                            "America/Los_Angeles",
                            "America/Louisville",
                            "America/Lower_Princes",
                            "America/Maceio",
                            "America/Managua",
                            "America/Manaus",
                            "America/Marigot",
                            "America/Martinique",
                            "America/Matamoros",
                            "America/Mazatlan",
                            "America/Mendoza",
                            "America/Menominee",
                            "America/Merida",
                            "America/Metlakatla",
                            "America/Mexico_City",
                            "America/Miquelon",
                            "America/Moncton",
                            "America/Monterrey",
                            "America/Montevideo",
                            "America/Montreal",
                            "America/Montserrat",
                            "America/Nassau",
                            "America/New_York",
                            "America/Nipigon",
                            "America/Nome",
                            "America/Noronha",
                            "America/North_Dakota/Beulah",
                            "America/North_Dakota/Center",
                            "America/North_Dakota/New_Salem",
                            "America/Nuuk",
                            "America/Ojinaga",
                            "America/Panama",
                            "America/Pangnirtung",
                            "America/Paramaribo",
                            "America/Phoenix",
                            "America/Port-au-Prince",
                            "America/Port_of_Spain",
                            "America/Porto_Acre",
                            "America/Porto_Velho",
                            "America/Puerto_Rico",
                            "America/Punta_Arenas",
                            "America/Rainy_River",
                            "America/Rankin_Inlet",
                            "America/Recife",
                            "America/Regina",
                            "America/Resolute",
                            "America/Rio_Branco",
                            "America/Rosario",
                            "America/Santa_Isabel",
                            "America/Santarem",
                            "America/Santiago",
                            "America/Santo_Domingo",
                            "America/Sao_Paulo",
                            "America/Scoresbysund",
                            "America/Shiprock",
                            "America/Sitka",
                            "America/St_Barthelemy",
                            "America/St_Johns",
                            "America/St_Kitts",
                            "America/St_Lucia",
                            "America/St_Thomas",
                            "America/St_Vincent",
                            "America/Swift_Current",
                            "America/Tegucigalpa",
                            "America/Thule",
                            "America/Thunder_Bay",
                            "America/Tijuana",
                            "America/Toronto",
                            "America/Tortola",
                            "America/Vancouver",
                            "America/Virgin",
                            "America/Whitehorse",
                            "America/Winnipeg",
                            "America/Yakutat",
                            "America/Yellowknife",
                            "Antarctica/Casey",
                            "Antarctica/Davis",
                            "Antarctica/DumontDUrville",
                            "Antarctica/Macquarie",
                            "Antarctica/Mawson",
                            "Antarctica/McMurdo",
                            "Antarctica/Palmer",
                            "Antarctica/Rothera",
                            "Antarctica/South_Pole",
                            "Antarctica/Syowa",
                            "Antarctica/Troll",
                            "Antarctica/Vostok",
                            "Arctic/Longyearbyen",
                            "Asia/Aden",
                            "Asia/Almaty",
                            "Asia/Amman",
                            "Asia/Anadyr",
                            "Asia/Aqtau",
                            "Asia/Aqtobe",
                            "Asia/Ashgabat",
                            "Asia/Ashkhabad",
                            "Asia/Atyrau",
                            "Asia/Baghdad",
                            "Asia/Bahrain",
                            "Asia/Baku",
                            "Asia/Bangkok",
                            "Asia/Barnaul",
                            "Asia/Beirut",
                            "Asia/Bishkek",
                            "Asia/Brunei",
                            "Asia/Calcutta",
                            "Asia/Chita",
                            "Asia/Choibalsan",
                            "Asia/Chongqing",
                            "Asia/Chungking",
                            "Asia/Colombo",
                            "Asia/Dacca",
                            "Asia/Damascus",
                            "Asia/Dhaka",
                            "Asia/Dili",
                            "Asia/Dubai",
                            "Asia/Dushanbe",
                            "Asia/Famagusta",
                            "Asia/Gaza",
                            "Asia/Harbin",
                            "Asia/Hebron",
                            "Asia/Ho_Chi_Minh",
                            "Asia/Hong_Kong",
                            "Asia/Hovd",
                            "Asia/Irkutsk",
                            "Asia/Istanbul",
                            "Asia/Jakarta",
                            "Asia/Jayapura",
                            "Asia/Jerusalem",
                            "Asia/Kabul",
                            "Asia/Kamchatka",
                            "Asia/Karachi",
                            "Asia/Kashgar",
                            "Asia/Kathmandu",
                            "Asia/Katmandu",
                            "Asia/Khandyga",
                            "Asia/Kolkata",
                            "Asia/Krasnoyarsk",
                            "Asia/Kuala_Lumpur",
                            "Asia/Kuching",
                            "Asia/Kuwait",
                            "Asia/Macao",
                            "Asia/Macau",
                            "Asia/Magadan",
                            "Asia/Makassar",
                            "Asia/Manila",
                            "Asia/Muscat",
                            "Asia/Nicosia",
                            "Asia/Novokuznetsk",
                            "Asia/Novosibirsk",
                            "Asia/Omsk",
                            "Asia/Oral",
                            "Asia/Phnom_Penh",
                            "Asia/Pontianak",
                            "Asia/Pyongyang",
                            "Asia/Qatar",
                            "Asia/Qostanay",
                            "Asia/Qyzylorda",
                            "Asia/Rangoon",
                            "Asia/Riyadh",
                            "Asia/Saigon",
                            "Asia/Sakhalin",
                            "Asia/Samarkand",
                            "Asia/Seoul",
                            "Asia/Shanghai",
                            "Asia/Singapore",
                            "Asia/Srednekolymsk",
                            "Asia/Taipei",
                            "Asia/Tashkent",
                            "Asia/Tbilisi",
                            "Asia/Tehran",
                            "Asia/Tel_Aviv",
                            "Asia/Thimbu",
                            "Asia/Thimphu",
                            "Asia/Tokyo",
                            "Asia/Tomsk",
                            "Asia/Ujung_Pandang",
                            "Asia/Ulaanbaatar",
                            "Asia/Ulan_Bator",
                            "Asia/Urumqi",
                            "Asia/Ust-Nera",
                            "Asia/Vientiane",
                            "Asia/Vladivostok",
                            "Asia/Yakutsk",
                            "Asia/Yangon",
                            "Asia/Yekaterinburg",
                            "Asia/Yerevan",
                            "Atlantic/Azores",
                            "Atlantic/Bermuda",
                            "Atlantic/Canary",
                            "Atlantic/Cape_Verde",
                            "Atlantic/Faeroe",
                            "Atlantic/Faroe",
                            "Atlantic/Jan_Mayen",
                            "Atlantic/Madeira",
                            "Atlantic/Reykjavik",
                            "Atlantic/South_Georgia",
                            "Atlantic/St_Helena",
                            "Atlantic/Stanley",
                            "Australia/ACT",
                            "Australia/Adelaide",
                            "Australia/Brisbane",
                            "Australia/Broken_Hill",
                            "Australia/Canberra",
                            "Australia/Currie",
                            "Australia/Darwin",
                            "Australia/Eucla",
                            "Australia/Hobart",
                            "Australia/LHI",
                            "Australia/Lindeman",
                            "Australia/Lord_Howe",
                            "Australia/Melbourne",
                            "Australia/North",
                            "Australia/NSW",
                            "Australia/Perth",
                            "Australia/Queensland",
                            "Australia/South",
                            "Australia/Sydney",
                            "Australia/Tasmania",
                            "Australia/Victoria",
                            "Australia/West",
                            "Australia/Yancowinna",
                            "Brazil/Acre",
                            "Brazil/DeNoronha",
                            "Brazil/East",
                            "Brazil/West",
                            "Canada/Atlantic",
                            "Canada/Central",
                            "Canada/Eastern",
                            "Canada/Mountain",
                            "Canada/Newfoundland",
                            "Canada/Pacific",
                            "Canada/Saskatchewan",
                            "Canada/Yukon",
                            "CET",
                            "Chile/Continental",
                            "Chile/EasterIsland",
                            "CST6CDT",
                            "Cuba",
                            "EET",
                            "Egypt",
                            "Eire",
                            "EST",
                            "EST5EDT",
                            "Etc/GMT",
                            "Etc/GMT+0",
                            "Etc/GMT+1",
                            "Etc/GMT+10",
                            "Etc/GMT+11",
                            "Etc/GMT+12",
                            "Etc/GMT+2",
                            "Etc/GMT+3",
                            "Etc/GMT+4",
                            "Etc/GMT+5",
                            "Etc/GMT+6",
                            "Etc/GMT+7",
                            "Etc/GMT+8",
                            "Etc/GMT+9",
                            "Etc/GMT-0",
                            "Etc/GMT-1",
                            "Etc/GMT-10",
                            "Etc/GMT-11",
                            "Etc/GMT-12",
                            "Etc/GMT-13",
                            "Etc/GMT-14",
                            "Etc/GMT-2",
                            "Etc/GMT-3",
                            "Etc/GMT-4",
                            "Etc/GMT-5",
                            "Etc/GMT-6",
                            "Etc/GMT-7",
                            "Etc/GMT-8",
                            "Etc/GMT-9",
                            "Etc/GMT0",
                            "Etc/Greenwich",
                            "Etc/UCT",
                            "Etc/Universal",
                            "Etc/UTC",
                            "Etc/Zulu",
                            "Europe/Amsterdam",
                            "Europe/Andorra",
                            "Europe/Astrakhan",
                            "Europe/Athens",
                            "Europe/Belfast",
                            "Europe/Belgrade",
                            "Europe/Berlin",
                            "Europe/Bratislava",
                            "Europe/Brussels",
                            "Europe/Bucharest",
                            "Europe/Budapest",
                            "Europe/Busingen",
                            "Europe/Chisinau",
                            "Europe/Copenhagen",
                            "Europe/Dublin",
                            "Europe/Gibraltar",
                            "Europe/Guernsey",
                            "Europe/Helsinki",
                            "Europe/Isle_of_Man",
                            "Europe/Istanbul",
                            "Europe/Jersey",
                            "Europe/Kaliningrad",
                            "Europe/Kiev",
                            "Europe/Kirov",
                            "Europe/Kyiv",
                            "Europe/Lisbon",
                            "Europe/Ljubljana",
                            "Europe/London",
                            "Europe/Luxembourg",
                            "Europe/Madrid",
                            "Europe/Malta",
                            "Europe/Mariehamn",
                            "Europe/Minsk",
                            "Europe/Monaco",
                            "Europe/Moscow",
                            "Europe/Nicosia",
                            "Europe/Oslo",
                            "Europe/Paris",
                            "Europe/Podgorica",
                            "Europe/Prague",
                            "Europe/Riga",
                            "Europe/Rome",
                            "Europe/Samara",
                            "Europe/San_Marino",
                            "Europe/Sarajevo",
                            "Europe/Saratov",
                            "Europe/Simferopol",
                            "Europe/Skopje",
                            "Europe/Sofia",
                            "Europe/Stockholm",
                            "Europe/Tallinn",
                            "Europe/Tirane",
                            "Europe/Tiraspol",
                            "Europe/Ulyanovsk",
                            "Europe/Uzhgorod",
                            "Europe/Vaduz",
                            "Europe/Vatican",
                            "Europe/Vienna",
                            "Europe/Vilnius",
                            "Europe/Volgograd",
                            "Europe/Warsaw",
                            "Europe/Zagreb",
                            "Europe/Zaporozhye",
                            "Europe/Zurich",
                            "Factory",
                            "GB",
                            "GB-Eire",
                            "GMT",
                            "GMT+0",
                            "GMT-0",
                            "GMT0",
                            "Greenwich",
                            "Hongkong",
                            "HST",
                            "Iceland",
                            "Indian/Antananarivo",
                            "Indian/Chagos",
                            "Indian/Christmas",
                            "Indian/Cocos",
                            "Indian/Comoro",
                            "Indian/Kerguelen",
                            "Indian/Mahe",
                            "Indian/Maldives",
                            "Indian/Mauritius",
                            "Indian/Mayotte",
                            "Indian/Reunion",
                            "Iran",
                            "Israel",
                            "Jamaica",
                            "Japan",
                            "Kwajalein",
                            "Libya",
                            "MET",
                            "Mexico/BajaNorte",
                            "Mexico/BajaSur",
                            "Mexico/General",
                            "MST",
                            "MST7MDT",
                            "Navajo",
                            "NZ",
                            "NZ-CHAT",
                            "Pacific/Apia",
                            "Pacific/Auckland",
                            "Pacific/Bougainville",
                            "Pacific/Chatham",
                            "Pacific/Chuuk",
                            "Pacific/Easter",
                            "Pacific/Efate",
                            "Pacific/Enderbury",
                            "Pacific/Fakaofo",
                            "Pacific/Fiji",
                            "Pacific/Funafuti",
                            "Pacific/Galapagos",
                            "Pacific/Gambier",
                            "Pacific/Guadalcanal",
                            "Pacific/Guam",
                            "Pacific/Honolulu",
                            "Pacific/Johnston",
                            "Pacific/Kanton",
                            "Pacific/Kiritimati",
                            "Pacific/Kosrae",
                            "Pacific/Kwajalein",
                            "Pacific/Majuro",
                            "Pacific/Marquesas",
                            "Pacific/Midway",
                            "Pacific/Nauru",
                            "Pacific/Niue",
                            "Pacific/Norfolk",
                            "Pacific/Noumea",
                            "Pacific/Pago_Pago",
                            "Pacific/Palau",
                            "Pacific/Pitcairn",
                            "Pacific/Pohnpei",
                            "Pacific/Ponape",
                            "Pacific/Port_Moresby",
                            "Pacific/Rarotonga",
                            "Pacific/Saipan",
                            "Pacific/Samoa",
                            "Pacific/Tahiti",
                            "Pacific/Tarawa",
                            "Pacific/Tongatapu",
                            "Pacific/Truk",
                            "Pacific/Wake",
                            "Pacific/Wallis",
                            "Pacific/Yap",
                            "Poland",
                            "Portugal",
                            "PRC",
                            "PST8PDT",
                            "ROC",
                            "ROK",
                            "Singapore",
                            "Turkey",
                            "UCT",
                            "Universal",
                            "US/Alaska",
                            "US/Aleutian",
                            "US/Arizona",
                            "US/Central",
                            "US/East-Indiana",
                            "US/Eastern",
                            "US/Hawaii",
                            "US/Indiana-Starke",
                            "US/Michigan",
                            "US/Mountain",
                            "US/Pacific",
                            "US/Samoa",
                            "UTC",
                            "W-SU",
                            "WET",
                            "Zulu", 
                          ]